import { RouteConfig } from 'vue-router';

import store from '@/store/store';
import { tryParseInt } from '@/utils/number';
import ClubExams from '@/views/exam/List.vue';

export const clubExamsRoute: RouteConfig = {
  name: 'clubExams',
  path: 'exams',
  component: ClubExams,
  meta: { authorized: true, title: 'titles.club.exam' },
  beforeEnter: (to: any, from: any, next: any) => {
    store.commit('exam/setFilters', {
      clubId: tryParseInt(to.params.clubId),
      teamId: undefined,
      inheritedFromClub: undefined
    });
    store
      .dispatch('sport/list', { count: -1 })
      .then(() => next())
      .catch(() => store.dispatch('notifyError', { title: 'messages.sport.listError' }));
  }
};
